export default {
  CreditAccount1121: '1121',
  _111: '111'
};
